import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDepSs.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return /^(SS)$/.test(type)
        },

        canMountType(map, node, type) {
            return /^(CAT)$/.test(type)
        },

        //menuItemsInsertCommon(map, node) {
            //return [
                //{type: 'CAT'},
            //]
        //},

        //menuItemsInsertProduct(map, node) {
            //return [
                //{type: 'SS'},
            //]
        //},
    })
}
